import { Typography } from '@mui/material'
import { Button, Modal } from 'eezy-components'
import { useTranslation } from 'react-i18next'

const ChangesSubmitted = () => {
  const { t } = useTranslation()

  return (
    <>
      <Modal.Header>
        {t('application_rejected.modal.changes_submitted')}
      </Modal.Header>
      <Modal.Body>
        <Typography variant="body1" textAlign="center">
          {t('application_rejected.modal.changes_submitted_info')}
        </Typography>
      </Modal.Body>
      <Modal.Actions>
        <Button color="primary" onClick={() => window.location.reload()}>
          {t('close_window')}
        </Button>
      </Modal.Actions>
    </>
  )
}

export default ChangesSubmitted
